import type { PurchaseOrder } from '../../types/purchase/purchaseOrder';
import { fetchPurchaseOrderPdf } from './purchaseOrderApi';
import { printPdfBlob } from '../printPdfBlob';

/**
 * Prints the server-generated purchase order PDF (same document as download/email).
 */
export const printPurchaseOrder = async (
  po: Pick<PurchaseOrder, 'id' | 'po_number'>
): Promise<void> => {
  const { blob } = await fetchPurchaseOrderPdf(po.id, `${po.po_number}.pdf`);
  await printPdfBlob(blob);
};
